export default __webpack_public_path__ + "static/char-s-50-en-74386bc2be6079ebded0e182732cf488.webp";